import { Route } from "react-router-dom";
import Expenses from "./Expenses";
import ExpensesList from "./ListExpenses";
import AddExpenses from "./AddExpenses";
import UpdateExpenses from "./UpdateExpenses";

export default (
  <Route path="Expenses" exact element={<Expenses />}>
    <Route index element={<ExpensesList />} />
    <Route path="add" element={<AddExpenses />} />
    <Route path="edit/:id" element={<UpdateExpenses />} />
  </Route>
);
